import type { JwtPayload } from '@supabase/supabase-js';

export const useSupabaseUser = (): Ref<JwtPayload | null> => useState<JwtPayload | null>('supabase_user', () => null);
